module.exports = __webpack_public_path__ + "img/thumbnail_RedCrownedCrane_j_normal.63faa418.png";